import {getQuery, postQuery, putQuery} from "../../common/utils";
import axios from "axios";

const getApps = async () => {

  let result;
  try {
    result = await getQuery('settings/get_available_market_apps')
    result = result.data;
  }
  catch (error) {
    result = {code: 'error'};
    console.error(error)
  }

  return result;
}

const getAppsByType = async (params) => {
  let result;
  try {
    result = await getQuery(`settings/get_available_apps_by_type?type=${params.appType}&buid=${params.businessUid}`)
    result = result.data;
  }
  catch (error) {
    result = {code: 'error'};
    console.error(error)
  }

  return result;
}

const getExternalApps = async () => {

  let result;
  try {
    result = await getQuery('settings/get_external_applications')
    result = result.data;
  }
  catch (error) {
    result = {code: 'error'};
    console.error(error)
  }

  return result;
}


const installApp = async (params) => {

  let result;
  try {
    result = await postQuery('platform/v1/apps/manager/install_app', params)
    result = result.data;
  }
  catch (error) {
    result = {code: 'error'};
    console.error(error)
  }

  return result;
}

const uninstallApp = async (params) => {

  let result;
  try {
    result = await postQuery('platform/v1/apps/manager/uninstall_app', params)
    result = result.data;
  }
  catch (error) {
    result = {code: 'error'};
    console.error(error)
  }

  return result;
}

const logUpgradeButtonClicked = async (app_code_name) => {
  try {
    await postQuery('platform/v1/apps/manager/upgrade_clicked_log', {app_code_name: app_code_name})
  }
  catch (error) {
    result = {code: 'error'};
    console.error(error)
  }
}



const getCalendarSyncAppPermissions = async (staffUid) => {
  let result;
  try {
    result = await getQuery(`business/scheduling/v1/calendar_syncs?staff_uid=${staffUid}`,{new_api: true})
    result = result.data;
  }
  catch (error) {
    result = {code: 'error'};
    console.error(error)
  }

  return result;
}

const getCalendarSyncApp = async (businessUid) => {
  let result;
  try {
    result = await getQuery(`settings/get_available_apps_by_type?type=calendar_sync&buid=${businessUid}&translate_apps=true`)
    result = result.data;
  }
  catch (error) {
    result = {code: 'error'};
    console.error(error)
  }

  return result;
}

const updateCalendarSyncSettings = async (settingsObj) => {
  let result;
  try {
    result = await putQuery(`business/scheduling/v1/calendar_syncs`, {...settingsObj, new_api: true})
    result = result.data;
  }
  catch (error) {
    result = {code: 'error'};
    console.error(error)
  }

  return result;
}


// before connectToCalendarApp, create record in core
const createCalendarSyncRecord = async (staffUid, app_code_name) => {
  let result;
  try {
    result = await postQuery(`business/scheduling/v1/calendar_syncs`,{
      staff_uid: staffUid,
      new_api: true,
      app_code_name: app_code_name
    })
    result = result.data;
  }
  catch (error) {
    result = {code: 'error'};
    console.error(error)
  }

  return result;
}

const getWindowOptions = () => {
  let windowWidth = 902
  let windowHeight = 637
  windowHeight += 20
  let dualScreenLeft = window.screenLeft || window.screenX;
  let dualScreenTop =  window.screenTop || window.screenY;

  let width = window.innerWidth || document.documentElement.clientWidth  || screen.width;
  let height = window.innerHeight || document.documentElement.clientHeight || screen.height;

  let systemZoom = width / window.screen.availWidth;
  let left = (width - windowWidth) / 2 / systemZoom + dualScreenLeft
  let top = (height - windowHeight) / 2 / systemZoom + dualScreenTop
  return `scrollbars=yes, width=${windowWidth / systemZoom}, height=${windowHeight / systemZoom},top=${top},left=${left}`
}

const connectToCalendarApp = async (app_uri, staff_uid, business_uid, calendar_name, connectWindow, should_sync_after_connect, directory_name) => {
  return new Promise((res, rej) => {
    const MAX_ATTEMPTS = 10;
    const INTERVAL_DURATION = 3000;
    let connectUrl = `${app_uri}/accounts/initialConnection?staff_uid=${staff_uid}&business_uid=${business_uid}&should_sync_after_connect=${should_sync_after_connect}&directory=${directory_name}`
    if(!should_sync_after_connect) {
      connectUrl += `&exported_calendar_name=${encodeURIComponent(calendar_name)}`
    }
    connectWindow.location.href = connectUrl
    let attempts = 0;
    let intervalIdx = setInterval(async () => {
      const result = await getCalendarSyncAppPermissions(staff_uid)
      attempts++;
      if(connectWindow.closed) {
        clearInterval(intervalIdx)
        if (!result || !result.enabled) {
          rej(new Error('Failed to connect to calendar app'))
          return
        }
      }

      const finalize = (result, isSuccess) => {
        connectWindow.close();
        clearInterval(intervalIdx);
        if(isSuccess) {
          res(result);
        } else {
          rej(new Error('Failed to connect to calendar app'));
        }
      };

      if(result.enabled) {
        finalize(result, true);
      }
      else if(attempts > MAX_ATTEMPTS) {
        finalize(result, false);
      }
    }, INTERVAL_DURATION);
  })
}



const getSyncAccount = async (app_uri, staff_uid) => {
  try {
    const res = await axios.get(`${app_uri}/accounts?staff_uid=${staff_uid}`)
    return res.data.data.account
  } catch (error) {
    if (error?.response?.status === 422 && error?.response?.data?.errors[0]?.message === 'invalid_grant') {
      return {error: 'invalid_grant'}
    }
  }
}

const disconnectFromCalendarApp = async (staff_uid, app_uri, exported_calendar_name, shouldKeep) => {
  let queryToSend = ''
  if(exported_calendar_name) {
    queryToSend = 'keep_exported_calendar'
  } else {
    queryToSend = 'keep_exported_items'
  }
  return await axios.put(`${app_uri}/accounts/disconnectAccount?staff_uid=${staff_uid}`, {[queryToSend]: shouldKeep})
}

const updateAppSettings = async (app_uri, account_uid, { should_export, should_import, imported_calendar_uids, sync_at, new_exported_calendar_name}) => {
  const res =  axios.put(`${app_uri}/accounts/${account_uid}/sync`, {
    should_export,
    should_import,
    imported_calendar_uids,
    new_exported_calendar_name,
    sync_at,

  })
  return res.data
}

const updateSyncSettings = async (app_uri, account_uid, settingsObj) => {
  const updateCoreData = await updateCalendarSyncSettings(settingsObj)
  const updateApplicationData = await updateAppSettings(app_uri, account_uid, settingsObj)

  return [updateCoreData, updateApplicationData]
}

const connectToSync = async (app_uri, staff_uid, business_uid, calendar_name, should_sync_after_connect, directory_name, app_code_name) => {
  const connectWindow = window.open('', "_blank", getWindowOptions())
  await createCalendarSyncRecord(staff_uid, app_code_name)
  return await connectToCalendarApp(app_uri, staff_uid, business_uid, calendar_name, connectWindow, should_sync_after_connect, directory_name)
}

const appsWithBetaBadge = ['esignatures', 'tips'];

export const appsService = {
  getApps,
  getAppsByType,
  getExternalApps,
  installApp,
  uninstallApp,
  logUpgradeButtonClicked,
  getCalendarSyncApp,
  getCalendarSyncAppPermissions,
  connectToCalendarApp,
  disconnectFromCalendarApp,
  getSyncAccount,
  createCalendarSyncRecord,
  updateCalendarSyncSettings,
  updateAppSettings,
  updateSyncSettings,
  connectToSync,
  appsWithBetaBadge
};
